import React, { useState } from 'react';
import styled from 'styled-components';
import SearchBox from '../dashboard/serachBox';
import Banner from './../../static/img/banner.jpg';
import Widgets from '../dashboard/widgets'
import SearchResult from '../dashboard/searchResult';
import { connect } from 'react-redux';
import { AppState } from '../../store';
import { SearchResultInterface } from '../../store/base/types';
import { CONSTS } from '../elements/_constants';
type DashboardFrameProps = {
    className?: string,
    searchResult :SearchResultInterface,
    isSearching :boolean,
    searchQuery :string
}
const bannerWidth = '500px';
const bannerHeight = '95px';
const DashboardComponent = (props: DashboardFrameProps) => {
    const {searchResult, searchQuery} = props;
    const isSearching = props.searchQuery.length > 0;
    return (
        <div className={props.className}>
            <div className="_row">
                <SearchBox q={searchQuery} bannerWidth={bannerWidth} bannerHeight={bannerHeight}/>
                <img src={Banner} className="_banner"/>
            </div>
            { isSearching ? <SearchResult q={searchQuery} isSearching={props.isSearching} searchResult={searchResult}/>
             : <Widgets /> }
        </div>
    )
}
const Dashboard = styled(DashboardComponent)`
    ._row {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 29px;
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
            flex-direction: column; 
            margin-bottom: 15px;
        }
    }
    ._banner {
        width: ${bannerWidth};
        height: ${bannerHeight};
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) { 
            width: 100%;
            height: auto;
        }
        object-fit: cover;
        background: #FFFFFF;
        box-shadow: 0 0 0 1px rgba(63,63,68,0.05);
        border-radius: 12px;
    }
    @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
        padding: 15px;
    }
`

const mapStateToProps = (state :AppState) => ({
    searchResult : state.base.searchResult,
    isSearching : state.base.isSearching,
    searchQuery : state.base.searchQuery,
})
export default connect(mapStateToProps)(Dashboard);